import { Permissions, Pagination } from '@factorin/domain';

import { withUrl, list, put, remove, ItemRequest } from '../rest';


export type permissionGroupBody = {
    Name: string;
}

type PermissionsIds = {
    permissionIds: string[];
}

export type PermissionGroupsIds = {
    permissionGroupIds: string[];
}

export type NewPassword = {
    NewPassword: string;
}

const usersPart = withUrl('users');

export const users = {
    ...list<Permissions.Permission, Pagination.Request>(usersPart()),

    addPermission: put<ItemRequest & PermissionsIds, void>(
        ({ id, permissionIds }) => usersPart({
            path: `${id}/permissions`,
            body: permissionIds,
        }),
    ),
    removePermission: remove<ItemRequest & PermissionsIds, void>(
        ({ id, permissionIds }) => usersPart({
            path: `${id}/permissions`,
            query: { permissionIds },
        }),
    ),

    addPermissionGroup: put<ItemRequest & PermissionGroupsIds, void>(
        ({ id, permissionGroupIds }) => usersPart({
            path: `${id}/permissiongroups`,
            query: { permissionGroupIds },
        }),
    ),
    removePermissionGroup: remove<ItemRequest & PermissionGroupsIds, void>(
        ({ id, permissionGroupIds }) => usersPart({
            path: `${id}/permissiongroups`,
            query: { permissionGroupIds },
        }),
    ),

    changePassword: put<ItemRequest & NewPassword>(
        ({ id, NewPassword }) => usersPart({
            path: `${id}/password`,
            body: { NewPassword },
        }),
    ),

    resetPassword: put<ItemRequest>(
        ({ id }) => usersPart({
            path: `${id}/password/reset`,
        }),
    ),

    unblock: put<ItemRequest>(
        ({ id }) => usersPart({
            path: `${id}/unblock`,
        }),
    ),
};
